export default "__VITE_ASSET__518ab644__"